<template>
	<div>
		<Layout :navFixed="false" :withImage="true" :invert="true" :hideFooterDecoration="true" :loading="loading" class="bg-white">
				
			
			<div class="container-fluid" v-if="!loading && item" style="margin-top:120px">

				<div class="container mt-3 mb-5" >
					<div class="row">
						<div class="col-12 col-md-7">
							<div v-if="mainImage" class="main-image" :style="'background-image:url(' + mainImage.url + ')'"></div>
							<div v-else class="main-image" :style="'background-image:url(no-image.jpg)'"></div>

							<div class="">
								<VueSlickCarousel
									v-bind="slickOptions"
									v-if="!loading && item && item.gallery.length > 0"
								>
									<div v-for="image in item.gallery" :key="image.id" @click="()=>{
										mainImage = image
									}">
										<div class="image-gallery" :style="'background-image:url(' + image.urlThumb + ')'">
											<div class="zoom">
												<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-zoom"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg>
											</div>
										</div>
									</div>
								</VueSlickCarousel>
							</div>

						</div>
						<div class="col-12 col-md-5">
							
							<div class="data">
								<h3 class="category" v-if="item.subCategory && item.subCategory.category">{{ item.subCategory.category.title }} - {{ item.subCategory.title }}</h3>
								<h1 class="title mb-4">
									<strong>{{ item.name }}</strong>
								</h1>

								<div v-if="item.code"><strong>CÓDIGO:</strong> {{ item.code }}</div>
								<div>
									<strong>STOCK:</strong>
									<span v-if="item.hasStock" class="text-success"> Disponible</span>
									<span v-else class="text-danger"> No Disponible</span>
								</div>

								<div class="price mt-3" v-if="item.priceWithoutTaxes > 0">
									<span>U$S</span>
									<span class="price-value">{{ item.priceWithoutTaxes.toFixed(2) }}</span>
									<span>+iva</span>
								</div>

								<div class=" mt-4" v-if="variants.length>0">
									<div class="label">Opciones</div>
									<div class="variants">
										<template v-for="variant in variants" >
											<div 
												:key="variant.id" 
												:class="{selected: selectedVariant && variant.id==selectedVariant.id}" 
												@click="selectVariant(variant)">
												{{variant.name}}
											</div>
										</template>
									</div>
								</div>

								<p v-html="item.detail" class="detail mt-4"></p>
								
								<div class="mt-5" v-if="item">
									<BuyButton :product="item" :variant="selectedVariant" class="mt-2" />
									<router-link
										tag="a"
										:to="`/contacto?body=${encodeURI(`Buenos días/nDeseo obtener más información acerca del vehículo ${this.item.name}/n¡Muchas gracias!`)}`"
										class="btn btn-block btn-lg btn-secondary mt-2"
										v-if="!callme"
									>
										Consultar
									</router-link>

								</div>
								
								<a v-if="item.dataSheet" :href="item.dataSheet.url" target="_blank" class="btn btn-download mt-3">
									<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-file-download" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
										<desc>Download more icon variants from https://tabler-icons.io/i/file-download</desc>
										<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
										<path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
										<path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
										<path d="M12 17v-6"></path>
										<path d="M9.5 14.5l2.5 2.5l2.5 -2.5"></path>
									</svg>	
									Descargar ficha técnica
								</a>

							</div>
						</div>

					</div>
				</div>

			</div>

			

		</Layout>
	</div>
</template>

<script>
import Layout from '@/components/Layout'
import ProductCartBar from '@/components/ProductCartBar'
import BuyButton from '@/components/ecommerce/BuyButton'
import gql from 'graphql-tag'

export default {
	name: 'TiendaDetail',
	metaInfo() {
		return {
			title: this.item ? this.item.name : '',
		}
	},
	components: {
		Layout,
		ProductCartBar,
		BuyButton,
	},
	computed:{
		variants(){
			return this.item.variants.filter(variant => variant.hasStock)
		},
		
	},
	data() {
		return {
			mainImage: null,
			loading: true,
			item: null,
			callme: false,
			phone: null,
			sending: false,
			sended: false,
			scrolled: false,
			selectedVariant: null,
			slickOptions:{
				arrows: true,
				dots: false,
				slidesToShow: 5,
				slidesToScroll: 1,
				infinite: true,
				autoplay: true,
				responsive:[
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 5
						}
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 4,
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 4,
						}
					}
				]
			}
		}
	},
	mounted() {	
		window.addEventListener('scroll', this.onScroll)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll)
	},

	async beforeMount() {
		if (this.$route.params.slug) {
			await this.load()
			

		} else {
			this.$router.push('/')
		}
	},
	methods: {
		selectVariant(variant){
			if(this.selectedVariant && variant.id == this.selectedVariant.id){
				this.selectedVariant = null
			}else{
				this.selectedVariant = variant
			}
		},
		onScroll(e) {
			const dataContent = document.getElementsByClassName('data')[0]
			if (dataContent) {
				let diff = 0
				if (dataContent.clientHeight > window.innerHeight) {
					diff = dataContent.clientHeight - window.innerHeight
				}
				diff = diff + 100

				window.top.scrollY > diff ? (this.scrolled = true) : (this.scrolled = false)
			}
		},
		callMePlease() {
			this.callme = true
			this.$nextTick(() => {
				this.$refs.phoneInput.focus()
			})
		},
		callMePleaseClose() {
			this.callme = false
		},
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($slug: String) {
							product(slug: $slug) {
								id
								code
								name
								priceWithoutTaxes
								hasStock
								variants{
									id
									code
									name
									hasStock
									image {
										id
										type
										filename
										url
										urlThumb
									}
								}
								image {
									id
									type
									filename
									url
									urlThumb
								}
								gallery {
									id
									type
									filename
									url
									urlThumb
								}
								dataSheet {
									id
									type
									filename
									url
									urlThumb
								}
								subCategory{
									id title
									category{
										id title
									}
								}
								
								detail
							}
						}
					`,
					variables: { slug: this.$route.params.slug },
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.item = data.product
					this.loading = false
				
					if(this.variants.length >0){
						this.selectVariant(this.variants[0])
					}

					if(this.selectedVariant && this.selectedVariant.image) this.mainImage = this.selectedVariant.image
					if(this.item && this.item.image) this.mainImage= this.item.image

				})
				.catch((err) => {
					console.log(err)
					// this.$router.push('/')
				})
		},
		
		send() {
			if (!this.sending && this.phone) {
				this.sending = true
				const data = {
					subject: 'Solcitud de llamada',
					name: 'No definido',
					phone: this.phone,
					email: 'No definido',
					message: `Interesado en vehículo ${this.item.name} solciita ser llamado al teléfono ${this.phone}`,
				}

				this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: MessageInput!) {
								messageCreate(data: $data) {
									id
								}
							}
						`,
						variables: {
							data,
						},
					})
					.then(() => {
						this.sending = false
						this.sended = true
					})
					.catch((error) => {
						this.parseGQLErrors(error)
						this.sending = false
					})
			}
		},
	},
}
</script>

<style scoped lang="scss">
.main-image {
	width: 100%;
	background-color: #fff;
	aspect-ratio: 16/9;
	margin: auto;
	position: relative;
	overflow: hidden;
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;

	img {
		
	}
}

.data{
	margin-top: 3rem;

	.title{
		font-size: 1.7rem;
		font-weight: 500;
	}
	.price{
		
		font-size: 1.1rem;
		font-weight: 400;
		text-transform: uppercase;
		color: #3a78c9;

		.price-value{
			font-size: 1.5rem;
			font-weight: 600;
			margin: 0px 6px;
		}
	}
	p{
		margin-top: 16px;
		font-size: 1rem;
		font-weight: 300;
	}
	.category {
		font-size: .9rem;
		text-transform: uppercase;
		color: #595959;
	}
}

.data-item {
	display: flex;
	padding: 4px;
	align-items: center;
	font-size: 13px;

	svg {
		width: 18px;
		margin-right: 8px;
	}
}

.variants{
	display: flex;
	align-items: center;
	gap: 4px;

	& > div{
		box-shadow:inset 0px 0px 0px 1px #e3e3e3;
		border-radius: 4px;
		background-color: #fff;
		padding: 6px 16px;
		cursor: pointer;
		font-weight: 500;

		&:hover{
			box-shadow:inset 0px 0px 0px 2px #3a78c9;
		}
		&.selected{
			box-shadow:inset 0px 0px 0px 2px #3a78c9;
		}
	}

}

.badge-primary {
	background-color: #ec9721;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 500;
}

.image-gallery{
	width: calc(100% - 4px);
	aspect-ratio: 1/1;
	padding: 2px;
	border-radius: 4px;
	border: 1px solid #e3e3e3;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	position: relative;
	transition: all 0.3s ease-in-out;

	.zoom{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #00000050;
		display: flex;
		justify-content: center;
		align-items: center;
		opacity: 0;
		transition: all 0.3s ease-in-out;
		cursor: pointer;
		svg{
			width: 40px;
			height: 40px;
			color: #fff;
		}
	}
	&:hover .zoom{
		opacity: 1;
	}

}
.image-gallery:hover{
	border: 1px solid #cdcccc;
}


::v-deep slick-track {
    margin:auto;
}

::v-deep .slick-arrow{
	width: 50px;
	height: 50px;
	    z-index: 10;
	
	&.slick-prev{
		left: 36px;
		&:before{
			font-size: 40px;
		}
	}
	&.slick-next{
		right: 36px;
		&:before{
			font-size: 40px;
		}
	}
}

.btn.btn-call {
	height: 44px;
	transition: all 0.3s ease-in-out;
}
.btn.callme {
	display: flex;
	padding: 4px;
	align-items: center;
	background-color: #000000;
	input {
		border-radius: 20px;
		border: none;
		height: 34px;
		padding-left: 12px;
		width: 120px;
		font-size: 18px;
		margin: 0px 6px;
		outline: none;
	}
	.icon {
		margin-left: 8px;
		width: 20px;
		height: 20px;
		margin-right: 6px;
	}
	.btn-primary {
		background-color: #5a5a5a;
		color: #fff;
		height: 34px;
		align-items: center;
		padding: 0px 12px;
	}
}


.btn-download{
display: flex;
    padding: 10px 16px 10px 0px;
    align-items: center;
}

@media (min-width: 750px) {

	
}
</style>
